<template>
  <div>

  </div>
</template>

<script>
export default {
  name: "ItemSetting"
}
</script>

<style scoped>

</style>